import {
  RequireAuth,
  CenteredFixedWidthContainer,
  IconViewerContainer,
} from "@components";

class ElementBuilder {
  constructor(config, licenseType) {
    this.component = <config.component />;
    this.builtComponent = <config.component />;
    this.config = config;
    this.licenseType = licenseType;
  }

  withAuthContainer() {
    if (this.config.container) {
      return this;
    }

    this.builtComponent = this.config.requiresAuthentication ? (
      <RequireAuth>{this.builtComponent}</RequireAuth>
    ) : (
      this.builtComponent
    );
    return this;
  }

  withCenteredContainer() {
    // Apply CenteredFixedWidthContainer by default unless explicitly disabled
    // Skip if showIconViewer is true since IconViewerContainer already includes CenteredFixedWidthContainer
    if (
      this.config.useDefaultContainer !== false &&
      !this.config.container &&
      !this.config.showIconViewer
    ) {
      this.builtComponent = (
        <CenteredFixedWidthContainer>
          {this.builtComponent}
        </CenteredFixedWidthContainer>
      );
    }
    return this;
  }

  withIconViewerContainer() {
    if (this.config.showIconViewer) {
      this.builtComponent = (
        <IconViewerContainer>{this.builtComponent}</IconViewerContainer>
      );
    }
    return this;
  }

  withConditionalRender(conditionalvalue) {
    if (this.config.conditionalRender) {
      this.builtComponent = conditionalvalue ? (
        <this.config.conditionalRender />
      ) : (
        this.builtComponent
      );
    }
    return this;
  }

  withOwnContainer() {
    const Container = this.config.container;
    if (Container) {
      this.builtComponent = <Container>{this.component}</Container>;
    }
    return this;
  }

  build() {
    return this.builtComponent;
  }
}

export { ElementBuilder };
